import { CountingCirclesRecord } from 'api/api.types';

const COLOR_COUNTED = 'var(--color-wap-yes)';
const COLOR_NOT_COUNTED = '#fff';

const getMapColorProportional = (record: CountingCirclesRecord) => {
  const fillColor = record.finished ? COLOR_COUNTED : COLOR_NOT_COUNTED;
  return { hasData: true, fillColor };
};

export default getMapColorProportional;
